import { NextRouter } from "next/router";
import { getUrlWithQuery } from "@/libs/url";
import { QUERY_PARAM_APP, QUERY_PARAM_FROM } from "@/libs/queryParams";

/**
 * 新規事業者登録後のリダイレクト処理を制御するカスタムフック
 * @param router router
 * @param app app parameter for redirection to services
 */
export const useRegistrationRedirectParams = (
  router: NextRouter,
  app: string | string[]
) => {
  // app パラメータが 融資ポータルの場合は、事業者情報登録は行わない
  if (app == QUERY_PARAM_APP.loan) {
    router.push(getUrlWithQuery("/select-service", app));
  } else {
    // それ以外の場合は、事業者情報登録画面に遷移する
    const queryParams = {};
    if (app) {
      queryParams["app"] = app;
    }
    queryParams["from"] = QUERY_PARAM_FROM.registerCompany;
    router.push({
      pathname: "/register-company-info",
      query: queryParams,
    });
  }
};
